import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { generateColorMap } from "@/modules/vue/utils";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'RichDialogRow',
  props: {
    color: null
  },
  setup(__props) {
    const props = __props;
    const colorClassMap = generateColorMap({
      text: 700
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(FormGroup, {
        class: "my-2"
      }, {
        label: _withCtx(() => [_renderSlot(_ctx.$slots, "label")]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["font-bold", _unref(colorClassMap)[__props.color] ?? null])
        }, [_renderSlot(_ctx.$slots, "value")], 2)]),
        _: 3
      });
    };
  }
});